import { render } from "./AlertDanger.vue?vue&type=template&id=b21efa80"
import script from "./AlertDanger.vue?vue&type=script&lang=js"
export * from "./AlertDanger.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__